module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n9n2r5n-a6d85406e61c567a163ef3ec154dd84c.svg";